import React, { useState, useContext } from 'react'
import SyncClinicAddress from '../syncComponents/SyncAddress'
import ApplyCustomerAndLicense from './ApplyCustomerAndLicense'
import MemberHistoryModal from './MemberHistoryModal'
import StateContext from '../MemberContext'
import { SelectCustomer, AppointmentTypesSycle, AppointmentTypeSyclePro, AppointmentTypeBlueprint, SelectEndpointsField } from '../syncComponents/helpers'
import { useSelector } from 'react-redux'
import useFetchLoginToken from '../../hooks/useFetchLoginToken'
import { MemberActionContext } from '../../containers/MemberList'
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Button, Checkbox, FormControlLabel, IconButton, Tabs, Tab, Tooltip } from '@material-ui/core';

const MemberField = ({name, label, value, onChange, multiline, action, ...inputProps}) => {
    const Input = multiline ? 'textarea' : 'input'
    return (
        <div className="c-form__form-group">
            <label htmlFor={'edit-member-' + name}>{label}</label>
            <div className={'member-editor__input' + (action ? ' member-editor__input--action' : '')}>
                <Input id={'edit-member-' + name} name={name} className="form-control"
                    value={value == null ? '' : value} onChange={onChange} {...inputProps} />
                {action}
            </div>
        </div>
    )
}

const UpdateMember = ({member, onCloseModal, onClose, onRevert}) => {
    const [historyOpen, setHistoryOpen] = useState(false)
    const [passwordVisible, setPasswordVisible] = useState(false)
    const customers = useSelector(state => state.customers.items)
    const { onDeleteMember, onUpdateMember, onUpdateLicense} = useContext(MemberActionContext)
    const [memberInfo, setMemberInfo] = useState({
        ...member,
        parent_company_id: member.parent_company_id ? member.parent_company_id : null,
        appointment_type_id_new_patient:         member.appointment_type_id_new_patient ? member.appointment_type_id_new_patient : null,
        appointment_type_id_returning_patient:   member.appointment_type_id_returning_patient ? member.appointment_type_id_returning_patient : null,
        appointment_type_name_new_patient:       member.appointment_type_name_new_patient ? member.appointment_type_name_new_patient : null,
        appointment_type_name_returning_patient: member.appointment_type_name_returning_patient ? member.appointment_type_name_returning_patient : null,
        nextslot_endpoint: member.nextslot_endpoint ? member.nextslot_endpoint : "/v1/"
    })

  const { token } = useFetchLoginToken({
    memberInfo
  })

        const closeEditor = () => {
                if (onClose) onClose()
                else if (onCloseModal) onCloseModal()
        }

    const handleSubmit = (e) => {
        e.preventDefault();
        onUpdateMember(memberInfo);
        //put licenses and  back to pool
        if ( (member.customer._id !== memberInfo.customer_id) && member.license_id) {
            onUpdateLicense({
                _id: member.license_id,
                active: false
            })
        }
        closeEditor()
    }

    const handleDelete = (e) => {
        e.preventDefault();
        if (!window.confirm('Delete ' + (member.clinic_name || member.clinic_id) + '? This cannot be undone.')) return
        onDeleteMember(memberInfo._id);
        closeEditor()
    }

    const handleInputChange = (e) => {
        e.preventDefault();
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setMemberInfo({...memberInfo, [name]: value})
    }

    const handleCustomerChange = (e) => {
        e.preventDefault();
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (value !== member.customer._id) {
            setMemberInfo({...memberInfo, license_id: null, [name]: value, license: null});
        }
    }

    const renderField = (name, label, props = {}) => (
        <MemberField name={name} label={label} value={memberInfo[name]} onChange={handleInputChange} {...props} />
    )

    return (
        <StateContext.Provider value={{memberInfo, setMemberInfo, token}}>
            <div className="member-editor">
                <header className="member-editor__header">
                    <div>
                        <h2>Edit member</h2>
                        <p>{member.clinic_name || member.clinic_id}</p>
                    </div>
                    <Tooltip title="Close editor">
                        <IconButton size="small" aria-label="Close editor" onClick={closeEditor}><CloseIcon /></IconButton>
                    </Tooltip>
                </header>
                <Tabs value={historyOpen ? 1 : 0} onChange={(event, value) => setHistoryOpen(value === 1)}
                    className="member-editor__tabs" indicatorColor="primary" textColor="primary" aria-label="Member editor views">
                    <Tab id="member-details-tab" label="Details" aria-controls="member-details-panel" />
                    <Tab id="member-history-tab" label="History" aria-controls="member-history-panel" />
                </Tabs>
                <div id="member-details-panel" role="tabpanel" aria-labelledby="member-details-tab" hidden={historyOpen} className="member-editor__details">
                    {!member.customer ? (
                        <div className="member-editor__body">
                            <section className="member-editor__section">
                                <h3>Customer &amp; license</h3>
                                <ApplyCustomerAndLicense member={member} onCloseModal={closeEditor}
                                    onUpdateMember={onUpdateMember} onUpdateLicense={onUpdateLicense} />
                            </section>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="c-form member-editor__form">
                            <div className="member-editor__body">
                                <section className="member-editor__section">
                                    <h3>Clinic details</h3>
                                    <div className="member-editor__grid">
                                        {renderField('clinic_name', 'Clinic name', { required: true })}
                                        {renderField('account_number', 'Account number')}
                                        {renderField('clinic_id', 'Clinic ID')}
                                        {customers && <SelectCustomer key={memberInfo.customer_id} customers={customers}
                                            onChangeCustomer={handleCustomerChange} defaultValue={memberInfo.customer_id} />}
                                    </div>
                                </section>
                                <section className="member-editor__section">
                                    <h3>Scheduling connection</h3>
                                    <div className="member-editor__grid">
                                        <SelectEndpointsField />
                                        {memberInfo.nextslot_endpoint === '/blueprint/' ? renderField('apiKey', 'API key') : <>
                                            {renderField('username', 'Username', { autoComplete: 'off' })}
                                            {renderField('password', 'Password', {
                                                type: passwordVisible ? 'text' : 'password', autoComplete: 'new-password',
                                                action: <Tooltip title={passwordVisible ? 'Hide password' : 'Show password'}>
                                                    <IconButton type="button" size="small" aria-label={passwordVisible ? 'Hide password' : 'Show password'}
                                                        onClick={() => setPasswordVisible(!passwordVisible)}>
                                                        {passwordVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                                    </IconButton>
                                                </Tooltip>
                                            })}
                                        </>}
                                    </div>
                                </section>
                                <section className="member-editor__section">
                                    <h3>Appointment types</h3>
                                    {memberInfo.parent_company_id && <AppointmentTypeSyclePro />}
                                    {memberInfo.nextslot_endpoint === '/v1/' && <AppointmentTypesSycle />}
                                    {memberInfo.nextslot_endpoint === '/blueprint/' && <AppointmentTypeBlueprint />}
                                </section>
                                <section className="member-editor__section">
                                    <h3>Address &amp; contact</h3>
                                    <div className="member-editor__grid">
                                        {memberInfo.nextslot_endpoint !== '/blueprint/' ? <SyncClinicAddress handleInputChange={handleInputChange} /> : <>
                                            {renderField('street1', 'Street address')}
                                            {renderField('street2', 'Address line 2')}
                                            {renderField('city', 'City')}
                                            {renderField('state', 'State')}
                                            {renderField('zip', 'Postal code')}
                                            {renderField('phone', 'Phone', { type: 'tel', value: memberInfo.phone || memberInfo.phone1 || '' })}
                                            {renderField('clinic_timezone', 'Clinic time zone')}
                                        </>}
                                        {renderField('email', 'Email')}
                                        {renderField('notification_emails', 'Notification emails')}
                                    </div>
                                </section>
                                <section className="member-editor__section">
                                    <h3>Audit settings</h3>
                                    <div className="member-editor__audit">
                                        <FormControlLabel label="Exclude from audits" control={<Checkbox name="audit_excluded" color="primary"
                                            checked={Boolean(memberInfo.audit_excluded)}
                                            onChange={event => setMemberInfo({ ...memberInfo, audit_excluded: event.target.checked })} />} />
                                        <FormControlLabel label="Has issues" control={<Checkbox name="has_issues" color="primary"
                                            checked={Boolean(memberInfo.has_issues)}
                                            onChange={event => setMemberInfo({ ...memberInfo, has_issues: event.target.checked })} />} />
                                    </div>
                                </section>
                                <section className="member-editor__section">
                                    <h3>Patient messages</h3>
                                    {renderField('thank_you_message', 'Thank you message', { multiline: true, rows: 3 })}
                                    {renderField('patient_email_message', 'Patient email message', { multiline: true, rows: 3 })}
                                </section>
                            </div>
                            <footer className="member-editor__footer">
                                <Button type="button" size="small" className="member-editor__delete" startIcon={<DeleteOutlineIcon />}
                                    onClick={handleDelete}>Delete</Button>
                                <div className="member-editor__footer-actions">
                                    <Button type="button" size="small" onClick={closeEditor}>Cancel</Button>
                                    <Button type="submit" size="small" variant="contained" color="primary" disableElevation startIcon={<SaveIcon />}>Save changes</Button>
                                </div>
                            </footer>
                        </form>
                    )}
                </div>
                {historyOpen && <div id="member-history-panel" role="tabpanel" aria-labelledby="member-history-tab" className="member-editor__history">
                    <MemberHistoryModal member={member} open={historyOpen} embedded onClose={() => setHistoryOpen(false)}
                        onRevert={restored => { setMemberInfo({ ...restored, nextslot_endpoint: restored.nextslot_endpoint || '/v1/' }); setHistoryOpen(false); if (onRevert) onRevert(restored) }} />
                </div>}
            </div>
        </StateContext.Provider>
    )
}

export default UpdateMember;
